import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'
import store from './stores'
import GmapCluster from "vue2-google-maps/dist/components/cluster"
import router from './router'

Vue.component('GmapCluster', GmapCluster)

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAVx5gJCh9MATmWOFIXOONY-YCc9R3yPlg',
		libraries: 'visualization',
  }
})

new Vue({
  vuetify,
	store,
  router,
  render: h => h(App)
}).$mount('#app')
